// react
import { useState } from 'react';

// types
import { Frame, User } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditUser } from '../../forms/FormEditUser/FormEditUser';

// props
export interface DialogEditUserProps {
	frame?: Frame;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
	user: User;
}

export const DialogEditUser = ({
	frame,
	isOpen,
	onClose,
	onSuccess,
	user,
}: DialogEditUserProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveUser'),
					form: 'form-edit-user',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={580}
			onClose={onClose}
			title={{
				children: t('editUser'),
				variant: 'h3',
			}}>
			<FormEditUser
				frame={frame}
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
				user={user}
			/>
		</DialogActions>
	);
};
